import { ErrorToast, SuccessToast } from "../toasts/Toasts";

export default function ResponseHandler(response){
    if (response?.status === 400 && response?.data?.message) {
       return ErrorToast(response.data.message)
    }else if(response?.status === 200 || response?.status === 201){
        return SuccessToast(response.data.message)
    }
}